import { ActiveFiltersMap } from 'clickNgo/components/dataFilterBar'
import { getContactStateKey, IContact } from 'clickNgo/entities/contact'
import { IContactFlags } from 'clickNgo/entities/contactFlag'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'

const contactProlfilingCodeTypes = [
  ProfilingCodeType.UserRights,
  ProfilingCodeType.Campaigns,
  ProfilingCodeType.Tools,
]

const phoneFields = ['mobilePhoneNumber', 'workPhoneNumber']

export const filterByIndividualFilters = (
  contacts: IContact[],
  contactFlagsById: Record<string, IContactFlags>,
  filters: ActiveFiltersMap
): IContact[] => {
  let filteredContacts = contacts

  Object.entries(filters).forEach(([filterId, filterValue]) => {
    filteredContacts = filteredContacts.filter((contact) => {
      if (contactProlfilingCodeTypes.includes(filterId as ProfilingCodeType)) {
        const flags =
          contactFlagsById[getContactStateKey(contact)]?.[filterId as keyof IContactFlags] || []
        const flagValues = flags.map((flag) => flag.code).filter(Boolean)
        return flagValues.some((val) =>
          val.toLowerCase().includes(String(filterValue).toLowerCase())
        )
      }

      const contactValue = contact[filterId as keyof IContact]
      const contactValueString = String(contactValue).toLowerCase()

      if (Array.isArray(filterValue)) {
        return filterValue.some((val) =>
          contactValueString.includes(String(val).toLowerCase().trim())
        )
      }

      if (phoneFields.includes(filterId)) {
        const normalizedContactPhone = contactValueString.replace(/\D/g, '')
        const normalizedFilterPhone = String(filterValue).toLowerCase().replace(/\D/g, '')
        return normalizedContactPhone.includes(normalizedFilterPhone)
      }

      return contactValueString.includes(String(filterValue).toLowerCase().trim())
    })
  })

  return filteredContacts
}
